import React from 'react';

class Spinner extends React.Component {
  constructor() {
    super();
  }

  render() {
    return(
      <div className="loaderWrap" style={{display: 'block'}}>
        <div className="loader">
          <div className="spinner">
            <svg id="Warstwa_1" style={{enableBackground: 'new 0 0 200 200'}} version="1.1" viewBox="0 0 200 200" x="0px" y="0px">
              <path className="ideaerp_logo_0" d="M50.3,139.9l-29.4,40.2l50.7-20C71.6,160.1,50.7,140.6,50.3,139.9z"></path>
              <path className="ideaerp_logo_1" d="M179.5,98.7l-2-16.7c-0.5-3.9-3.9-6.7-7.8-6.5l-2.5,0.2c-3,0.2-5.9-1.5-7.2-4.3c-1.7-3.7-3.6-7.1-5.8-10.4                             c-1.7-2.5-1.7-5.8,0.1-8.3l1.5-2.1c2.3-3.2,1.6-7.6-1.5-10l-13.2-10.4c-3.1-2.4-7.5-2-10.1,0.9l-1.7,1.9c-2,2.3-5.2,3.1-8,2                             c-3.7-1.4-7.5-2.5-11.5-3.2c-3-0.6-5.3-3-5.8-6l-0.4-2.5c-0.7-3.9-4.2-6.5-8.1-6.1l-16.7,2c-3.9,0.5-6.8,3.9-6.5,7.8l0.2,2.5                             c0.2,3-1.5,5.9-4.3,7.2c-3.7,1.7-7.1,3.6-10.4,5.8c-2.5,1.7-5.8,1.7-8.3-0.1l-2.1-1.5c-3.2-2.3-7.6-1.6-10,1.5L26.8,55.6                             c-2.4,3.1-2,7.5,0.9,10.1l1.9,1.7c2.3,2,3.1,5.2,2,8c-1.4,3.7-2.5,7.5-3.2,11.5c-0.6,3-3,5.3-6,5.8L20,93.2                             c-3.9,0.7-6.5,4.2-6.1,8.1l2,16.7c0.5,3.9,3.9,6.7,7.8,6.5l2.5-0.2c3-0.2,5.9,1.5,7.2,4.3c1.7,3.7,3.6,7.1,5.8,10.4                             c1.7,2.5,1.7,5.8-0.1,8.3l-1.5,2.1c-2.3,3.2-1.6,7.6,1.5,10l13.2,10.4c3.1,2.4,7.5,2,10.1-0.9l1.7-1.9c2-2.3,5.2-3.1,8-2                             c3.7,1.4,7.5,2.5,11.5,3.2c3,0.6,5.3,3,5.8,6l0.4,2.5c0.7,3.9,4.2,6.5,8.1,6.1l16.7-2c3.9-0.5,6.7-3.9,6.5-7.8l-0.2-2.5                             c-0.2-3,1.5-5.9,4.3-7.2c3.7-1.7,7.1-3.6,10.4-5.8c2.5-1.7,5.8-1.7,8.3,0.1l2.1,1.5c3.2,2.3,7.6,1.6,10-1.5l10.4-13.2                             c2.4-3.1,2-7.5-0.9-10.1l-1.9-1.7c-2.3-2-3.1-5.2-2-8c1.4-3.7,2.5-7.5,3.2-11.5c0.6-3,3-5.3,6-5.8l2.5-0.4                             C177.3,106.2,180,102.6,179.5,98.7z M96.7,154.7C66.5,154.7,42,130.2,42,100s24.5-54.7,54.7-54.7c30.2,0,54.7,24.5,54.7,54.7                             S126.9,154.7,96.7,154.7z"></path>
              <g>
                <path className="ideaerp_logo_0" d="M198,46.6L136.5,22v0v0L54.4,134.6c8.2,10,19.9,17.1,33.2,19.3l65.9-25.8L149,56.4L198,46.6z"></path>
              </g>
              <polygon className="ideaerp_logo_2" points="153.6,128.2 2.6,86.5 149,56.4 "></polygon>
              <polygon className="ideaerp_logo_3" points="153.6,128.1 66.1,118.5 74.9,106.5 "></polygon>
            </svg>
          </div>
          <span>Trwa ładowanie...</span>
        </div>
      </div>
    )
  }
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner.js